import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/welcome' },
  { path: 'welcome', loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomeModule) },
  { path: 'produtos', loadChildren: () => import('./pages/produtos/produtos.module').then(m => m.ProdutosModule) },
  { path: 'produto', loadChildren: () => import('./pages/produto/produto.module').then(m => m.ProdutoModule) },
  { path: 'acesso', loadChildren: () => import('./pages/acesso/acesso.module').then(m => m.AcessoModule) },
  { path: 'registro', loadChildren: () => import('./pages/registro/registro.module').then(m => m.RegistroModule) },
  { path: 'automotivo', loadChildren: () => import('./pages/automotive/automotive.module').then(m => m.AutomotiveModule) },
  { path: 'negociacoes', loadChildren: () => import('./pages/negociacoes/negociacoes.module').then(m => m.NegociacoesModule) },
  { path: 'negociacao', loadChildren: () => import('./pages/negociacao/negociacao.module').then(m => m.NegociacaoModule) },
  { path: 'minha-conta', loadChildren: () => import('./pages/minha-conta/minha-conta.module').then(m => m.MinhaContaModule) },
  { path: 'checkout', loadChildren: () => import('./pages/checkout/checkout.module').then(m => m.CheckoutModule) },
  { path: 'venda', loadChildren: () => import('./pages/venda/venda.module').then(m => m.VendaModule) },
  { path: 'compra', loadChildren: () => import('./pages/compra/compra.module').then(m => m.CompraModule) },
  { path: 'listas-favoritos', loadChildren: () => import('./pages/listas-favoritos/listas-favoritos.module').then(m => m.ListasFavoritosModule) },
  {
    path: 'vendedor/:id',
    loadComponent: () => import('./pages/seller-page/seller-page.component')
      .then(m => m.SellerPageComponent)
  },
  {
    path: 'recompra/responder',
    loadComponent: () => import('./pages/recompra-responder/recompra-responder.component')
      .then(m => m.RecompraResponderComponent)
  },
  // { path: 'lista-caixas', loadChildren: () => import('./pages/lista-caixas/lista-caixas.module').then(m => m.ListaCaixasModule) },
];

const routerOptions: ExtraOptions = {
  enableTracing: false,
  // useHash: false, // defined in app.module -> HashLocationStrategy
  // scrollOffset: () => { return [0, 0]; /* [x,y] */ },
  anchorScrolling: 'disabled', // 'enabled'
  scrollPositionRestoration: 'disabled', // | 'enabled' | 'top'
};
@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
